import Cookies from 'js-cookie';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { devtoolsDefaultOption } from '@/lib/zustand';

const isAccepted = () => {
  const policyValue = Cookies.get('cookie_policy');
  return policyValue === 'accepted';
};

const accept = () => {
  Cookies.set('cookie_policy', 'accepted', { path: '/' });
};

type CookiePolicyStore = {
  accepted: boolean;
  setAccepted: () => void;
};

export const useCookiePolicy = create<CookiePolicyStore>()(
  devtools(
    set => ({
      accepted: isAccepted(),
      setAccepted: () =>
        set(state => {
          accept();
          return {
            ...state,
            accepted: true,
          };
        }),
    }),
    { ...devtoolsDefaultOption, name: 'useCookiePolicy' },
  ),
);
